import { Box } from "@chakra-ui/react";
import { ACCENT_1_COLOR } from "../constants/color";

export default function CustomButton({
  children,
  onClick,
  disabled = false,
  ...props
}) {
  return (
    <Box
      as="button"
      py="8px"
      px="12px"
      border={`1px solid ${ACCENT_1_COLOR}`}
      color={ACCENT_1_COLOR}
      className="cormorant-garamond-normal"
      fontSize="15px"
      letterSpacing="2px"
      transition="all 0.3s ease"
      cursor={disabled ? "not-allowed" : "pointer"}
      opacity={disabled ? 0.6 : 1}
      _hover={
        !disabled
          ? {
              bg: ACCENT_1_COLOR,
              color: "#F7F5F0",
            }
          : {}
      }
      onClick={!disabled ? onClick : undefined}
      {...props}
    >
      {children}
    </Box>
  );
}